import React from 'react'
import { Source } from 'react-map-gl/maplibre'
import mapSettings from '../mapSettings'

// This is just the source data. Terrain is a special sort of layer in mapbox/maplibre.
// The actual layer is added to the map via the Map's terrain prop.

const TerrainSource = () => {
  return (
    <Source
      id={mapSettings.terrainDef.source}
      type='raster-dem'
      tiles={['https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png']}
      encoding='terrarium'
      attribution='© <a href="https://www.mapzen.com/rights">Mapzen</a>'
    />
  )
}

export default TerrainSource